import React, { useState } from 'react';
import '../../style/radiobutton.css'

const RadioButtonComponent = () => {
  const [selectedValue, setSelectedValue] = useState("");

  const handleChange = (e) => {
    setSelectedValue(e.target.value);
  };

  return (
    <div className="col-md-8 col-lg-8 col-xl-8">
      <form className="radio-form-container">
        {/* Header matching your screenshot style */}
        <h1 className="mb-3 fw-normal border-bottom text-left pb-2 mb-4">Radio Button</h1>
        
        <p className="text-left question-text">Do you like the site?</p>

        <div className="radio-group-inline">
          {/* YES OPTION */}
          <div className="form-check form-check-inline">
            <input 
              className="form-check-input" 
              type="radio" 
              name="tab" 
              id="yesRadio"
              value="Yes" 
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="yesRadio">Yes</label>
          </div>

          {/* IMPRESSIVE OPTION */}
          <div className="form-check form-check-inline">
            <input 
              className="form-check-input" 
              type="radio" 
              name="tab" 
              id="impressiveRadio"
              value="Impressive" 
              onChange={handleChange}
            />
            <label className="form-check-label" htmlFor="impressiveRadio">Impressive</label>
          </div>

          {/* DISABLED OPTION */}
          <div className="form-check form-check-inline">
            <input 
              className="form-check-input" 
              type="radio" 
              name="tab" 
              value="option3" 
              disabled 
            />
            <label className="form-check-label disabled-label" htmlFor="">No (Disable)</label>
          </div>
        </div>

        {/* CONDITIONAL MESSAGE */}
        {selectedValue && (
          <div className="selection-result">
            You have checked <b>{selectedValue}</b>
          </div>
        )}
      </form>
    </div>
  );
};

export default RadioButtonComponent;